import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="announcement-form"
export default class extends Controller {
  static targets = [
    "titleCounter",
    "titleField",
    "bodyCounter",
    "bodyField",
    "ctaLabel",
    "ctaUrl",
    "ctaPreview",
    "ctaPreviewText",
    "startsAt",
    "endsAt",
    "durationDisplay",
    "durationText"
  ]

  connect() {
    this.updateTitleCounter()
    this.updateBodyCounter()
    this.updateCtaPreview()
    this.updateDurationDisplay()
  }

  updateTitleCounter() {
    if (this.hasTitleCounterTarget && this.hasTitleFieldTarget) {
      this.titleCounterTarget.textContent = this.titleFieldTarget.value.length
    }
  }

  updateBodyCounter() {
    if (this.hasBodyCounterTarget && this.hasBodyFieldTarget) {
      this.bodyCounterTarget.textContent = this.bodyFieldTarget.value.length
    }
  }

  updateCtaPreview() {
    if (!this.hasCtaLabelTarget || !this.hasCtaUrlTarget || !this.hasCtaPreviewTarget) return

    if (this.ctaLabelTarget.value || this.ctaUrlTarget.value) {
      this.ctaPreviewTarget.classList.remove('hidden')
      if (this.hasCtaPreviewTextTarget) {
        this.ctaPreviewTextTarget.textContent = this.ctaLabelTarget.value || this.ctaPreviewTextTarget.dataset.defaultText
      }
    } else {
      this.ctaPreviewTarget.classList.add('hidden')
    }
  }

  setDuration(event) {
    const days = parseInt(event.currentTarget.dataset.days)

    if (!this.hasStartsAtTarget || !this.hasEndsAtTarget) return

    const startDate = new Date(this.startsAtTarget.value || new Date())
    const endDate = new Date(startDate)
    endDate.setDate(endDate.getDate() + days)

    this.endsAtTarget.value = endDate.toISOString().slice(0, 16)
    this.updateDurationDisplay()
  }

  updateDurationDisplay() {
    if (!this.hasStartsAtTarget || !this.hasEndsAtTarget || !this.hasDurationDisplayTarget) return

    if (this.startsAtTarget.value && this.endsAtTarget.value) {
      const start = new Date(this.startsAtTarget.value)
      const end = new Date(this.endsAtTarget.value)
      const diffTime = Math.abs(end - start)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (this.hasDurationTextTarget) {
        const daysText = this.durationTextTarget.dataset.daysText || 'days'
        this.durationTextTarget.textContent = `${diffDays} ${daysText}`
      }
      this.durationDisplayTarget.classList.remove('hidden')
    } else {
      this.durationDisplayTarget.classList.add('hidden')
    }
  }
}
